import React from "react";
import "./PaymentInstructions.css";

const PaymentMethodCard = ({ icon, title, details }) => (
  <div className="workshop-payment-method-card">
    <div className="workshop-payment-method-header">
      <span className="workshop-payment-method-icon">{icon}</span>
      <h6 className="workshop-payment-method-title">{title}</h6>
    </div>
    <div className="workshop-payment-details">
      {details.map((detail, index) => (
        <div key={index} className="workshop-payment-detail">
          <span className="workshop-detail-label">{detail.label}:</span>
          <span className="workshop-detail-value">{detail.value}</span>
        </div>
      ))}
    </div>
  </div>
);

const PaymentContactInfo = ({ contactInfo }) => (
  <div className="workshop-payment-contact-info">
    <h5>📞 Payment Support</h5>
    <div className="workshop-contact-methods">
      {contactInfo.whatsapp && (
        <div className="workshop-contact-method">
          <span className="workshop-contact-icon">📱</span>
          <a
            href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="workshop-contact-link"
          >
            {contactInfo.whatsapp}
          </a>
        </div>
      )}
      {contactInfo.email && (
        <div className="workshop-contact-method">
          <span className="workshop-contact-icon">📧</span>
          <a
            href={`mailto:${contactInfo.email}`}
            className="workshop-contact-link"
          >
            {contactInfo.email}
          </a>
        </div>
      )}
    </div>
  </div>
);

const PaymentInstructionsDisplay = ({
  workshop,
  showTitle = true,
  compact = false,
}) => {
  // ✅ FIXED: Access paymentInstructions from pricing object (backend structure)
  const pricing = workshop.pricing || {};
  const paymentInstructions = pricing.paymentInstructions;

  // Don't show for free workshops or if no instructions
  if (pricing?.type !== "paid" || !paymentInstructions) {
    return null;
  }

  return (
    <div
      className={`workshop-payment-instructions ${
        compact ? "compact" : "full"
      }`}
    >
      {showTitle && (
        <div className="workshop-payment-header">
          <h4>💳 Payment Instructions</h4>
          <div className="workshop-amount">
            <strong>
              Amount: {pricing.amount} {pricing.currency}
            </strong>
          </div>
        </div>
      )}

      <div className="workshop-payment-methods">
        {/* Bank Transfer - ✅ FIXED: Only show if accountNumber exists */}
        {paymentInstructions.bankDetails?.accountNumber && (
          <PaymentMethodCard
            icon="🏦"
            title="Bank Transfer"
            details={[
              {
                label: "Account Title",
                value: paymentInstructions.bankDetails.accountTitle,
              },
              {
                label: "Account Number",
                value: paymentInstructions.bankDetails.accountNumber,
              },
              {
                label: "Bank Name",
                value: paymentInstructions.bankDetails.bankName,
              },
              { label: "IBAN", value: paymentInstructions.bankDetails.iban },
            ].filter((item) => item.value)} // ✅ FIXED: Filter empty values
          />
        )}

        {/* EasyPaisa - ✅ FIXED: Only show if accountNumber exists */}
        {paymentInstructions.mobilePayment?.easypaisa?.accountNumber && (
          <PaymentMethodCard
            icon="📱"
            title="EasyPaisa"
            details={[
              {
                label: "Account Number",
                value:
                  paymentInstructions.mobilePayment.easypaisa.accountNumber,
              },
              {
                label: "Account Title",
                value: paymentInstructions.mobilePayment.easypaisa.accountTitle,
              },
            ].filter((item) => item.value)} // ✅ FIXED: Filter empty values
          />
        )}

        {/* JazzCash - ✅ FIXED: Only show if accountNumber exists */}
        {paymentInstructions.mobilePayment?.jazzcash?.accountNumber && (
          <PaymentMethodCard
            icon="📱"
            title="JazzCash"
            details={[
              {
                label: "Account Number",
                value: paymentInstructions.mobilePayment.jazzcash.accountNumber,
              },
              {
                label: "Account Title",
                value: paymentInstructions.mobilePayment.jazzcash.accountTitle,
              },
            ].filter((item) => item.value)} // ✅ FIXED: Filter empty values
          />
        )}

        {/* PayPal - ✅ FIXED: Only show if email exists */}
        {paymentInstructions.internationalPayment?.paypal?.email && (
          <PaymentMethodCard
            icon="🌍"
            title="PayPal"
            details={[
              {
                label: "Email",
                value: paymentInstructions.internationalPayment.paypal.email,
              },
            ]}
          />
        )}

        {/* Wise - ✅ FIXED: Only show if email exists */}
        {paymentInstructions.internationalPayment?.wise?.email && (
          <PaymentMethodCard
            icon="🌍"
            title="Wise (Formerly TransferWise)"
            details={[
              {
                label: "Email",
                value: paymentInstructions.internationalPayment.wise.email,
              },
            ]}
          />
        )}
      </div>

      {/* Additional Instructions - ✅ FIXED: Proper conditional rendering */}
      {paymentInstructions.additionalInstructions && (
        <div className="workshop-additional-instructions">
          <h5>📝 Important Instructions</h5>
          <p>{paymentInstructions.additionalInstructions}</p>
        </div>
      )}

      {/* Contact Support - ✅ FIXED: Proper conditional check */}
      {(paymentInstructions.contactInfo?.whatsapp ||
        paymentInstructions.contactInfo?.email) && (
        <PaymentContactInfo contactInfo={paymentInstructions.contactInfo} />
      )}
    </div>
  );
};

export default PaymentInstructionsDisplay;
